import classNames from 'classnames'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { getFormatDate } from 'core/classes/helpers/DateHelper'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { selectDNALoadDate, selectEmptyOfferings } from 'partner360/features/QBR'

import styles from './DocumentDataInformation.module.scss'

export const DocumentDataInformation = () => {
  const dnaLoadDate = useSelector(selectDNALoadDate)
  const emptyOfferings = useSelector(selectEmptyOfferings)

  const displayedDnaLoadDate = useMemo(() => {
    if (dnaLoadDate) {
      return getFormatDate(dnaLoadDate, 'date') || '-'
    }
    return '-'
  }, [dnaLoadDate])

  const displayedEmptyOfferings = useMemo(() => {
    if (emptyOfferings) {
      return emptyOfferings.join(', ')
    }

    return null
  }, [emptyOfferings])

  return (
    <div className={styles.root}>
      <div>
        <i className={classNames('kbase kbase-warning-alt', styles.icon)} />
      </div>
      <div>
        <div>
          <Translation
            text={TRANSLATION_KEYS.dnaLoadDate}
            replaceParams={[{ key: '{dna}', value: displayedDnaLoadDate }]}
          />
        </div>

        {displayedEmptyOfferings ? (
          <div>
            <Translation
              text={TRANSLATION_KEYS.emptyOfferings}
              replaceParams={[{ key: '{emptyOfferings}', value: displayedEmptyOfferings }]}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}
